
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Blob01:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M126.573 56.7441C129.853 74.741 127.664 92.4501 118.067 105.712C108.425 118.977 91.416 127.747 72.0162 127.993C52.6163 128.238 34.1062 122.385 19.9955 110.93C5.90907 99.4947 -0.200558 82.242 0.00499937 65.7279C0.234824 49.2345 6.75861 33.5038 19.289 21.6772C31.7951 9.83008 46.7306 2.10177 62.645 0.373659C78.514 -1.35098 95.3377 2.90402 106.539 12.9448C117.741 22.9857 123.293 38.7472 126.573 56.7441Z" fill="#0C0D0D"/>
</svg>

  }
  
